import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIteoWhiteLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 163 49",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	x: "0px",
	y: "0px",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.4112 17.1671L2.5689 17.2302L8.11752 22.7788C8.15958 22.8472 8.15432 22.9181 8.1517 22.9944C8.14907 23.5411 7.92829 24.3428 7.89674 24.9525C7.44203 34.1179 15.3773 41.6904 24.5111 40.8677C34.9039 39.9294 41.4225 28.9872 37.1039 19.3934C36.9909 19.1437 36.3837 17.9005 36.2444 17.7927C36.2024 17.7611 36.1892 17.727 36.1235 17.7401C36.0788 17.748 35.5137 18.1843 35.3849 18.2658C28.4511 22.6027 20.0322 23.1547 12.7725 19.1963C9.68671 17.5141 7.2738 15.1012 4.93712 12.5437C7.20546 10.0914 9.46066 7.79148 12.394 6.12505C27.9044 -2.68021 46.9238 9.78647 45.5439 27.4101C43.9694 47.5282 18.4762 55.424 5.69148 39.7007C0.571287 33.403 -0.61939 24.7002 2.4112 17.1671ZM15.5902 12.5043C19.3988 15.0959 24.5242 15.3167 28.7692 13.6687C29.0373 13.5635 30.8798 12.7382 30.914 12.5963C30.9376 12.499 30.8298 12.4675 30.7694 12.428C29.923 11.8787 28.4721 11.3215 27.4944 11.0376C23.4492 9.86269 19.2095 10.3779 15.5902 12.5043Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.118 0.766923L39.3262 5.56543L44.3181 10.5504L49.1099 5.75188L44.118 0.766923Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M127.274 30.4679H106.527C106.882 33.2593 108.706 35.5172 111.508 36.1112C114.31 36.7052 117.333 35.83 118.918 33.3697H126.769C125.137 38.122 121.079 41.694 116.113 42.6061C105.092 44.6273 96.7681 35.0362 99.4938 24.3568C102.927 10.9097 122.38 10.2632 126.672 23.3501C127.416 25.6159 127.615 28.1129 127.274 30.4706V30.4679ZM120.019 25.4266C119.331 22.8902 117.475 20.8899 114.849 20.3511C111.022 19.5652 107.579 21.6049 106.712 25.4266H120.017H120.019Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.23 8.4707V15.2784H94.3557V20.9505H87.3247L87.2274 21.1687C87.3851 24.9273 87.0303 28.8411 87.2274 32.584C87.3063 34.0822 87.7452 35.4805 89.1856 36.1744C89.4484 36.3006 90.279 36.5845 90.5392 36.5845H94.4819V42.8875C90.7705 42.7692 86.6597 43.4946 83.5161 41.0843C81.4422 39.4941 80.4408 37.1732 80.2305 34.5974V21.1687L80.1359 20.9505H75.502V15.2784H80.2305V8.4707H87.23Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.5626 18.1152H61.5V42.8883H68.5626V18.1152Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.5626 8.47168H61.5V15.2162H68.5626V8.47168Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M146.432 13.9082C156.943 13.3378 164.629 22.4716 161.595 32.7225C157.548 46.4062 136.672 46.1828 133.029 32.3729C130.556 22.9973 136.791 14.4312 146.432 13.9082ZM146.873 20.842C137.303 21.4281 137.729 36.631 148.177 35.8872C151.421 35.6559 154.002 33.1983 154.559 30.0363C155.455 24.966 152.22 20.5134 146.873 20.8394V20.842Z",
			fill: "white"
		})
	]
});
export default SvgIteoWhiteLogo;
